import { Field, Form } from 'factorial-form'
import {
  DataDispatcherFieldSetInput,
  DataSchemaItemFragment,
  EmployeeDatumFieldFragment,
} from 'generated/resources/graphql'
import { Dictionary } from 'lodash'

import { dateToString, stringToDate } from 'modules/core/lib/dates'

export class PayrollEmployeeDataForm extends Form {
  constructor(
    employeePayrollDataSchema: DataSchemaItemFragment[],
    fieldsData: Dictionary<EmployeeDatumFieldFragment>
  ) {
    const { values, schema } = PayrollEmployeeDataForm.initialize(
      employeePayrollDataSchema,
      fieldsData
    )
    super(values, schema)
  }

  get serializedData(): DataDispatcherFieldSetInput[] {
    if (!this.fields) return []

    return Object.keys(this.fields).map((key: string) => {
      const field = this.get(key)
      return {
        fieldName: key,
        fieldValue: this.parseFieldValue(field),
      }
    })
  }

  parseFieldValue(field: Field) {
    const value = field.value
    if (value === '') return null
    if (field.type == 'date') {
      const date = stringToDate(value, 'ui')
      return dateToString(date, 'backend')
    }

    return value.toString()
  }

  static initialize = (
    employeePayrollDataSchema: DataSchemaItemFragment[],
    fieldsData: Dictionary<EmployeeDatumFieldFragment>
  ) => {
    const values: Record<string, number | string | null | boolean | undefined> = {}
    const schema: Record<string, string> = {}

    employeePayrollDataSchema.forEach((dataSchemaItem) => {
      const identifier = dataSchemaItem.fieldName
      const fieldType = PayrollEmployeeDataForm.getFieldType(dataSchemaItem.fieldType)
      schema[identifier] = fieldType
      values[identifier] = PayrollEmployeeDataForm.getFieldValue(
        fieldType,
        fieldsData[identifier]?.fieldValue
      )
    })

    return {
      values,
      schema,
    }
  }

  static getFieldType = (fieldType: string) => {
    if (fieldType == 'integer') return 'number'

    return fieldType
  }

  static getFieldValue = (fieldType: string, fieldValue: string | undefined | null) => {
    if (fieldValue === undefined) return undefined

    switch (fieldType) {
      case 'number':
        return Number(fieldValue)
      case 'boolean':
        return fieldValue == 'true' ? true : false
      default:
        return fieldValue
    }
  }
}
